import * as React from 'react';
import { Box } from '@mui/material';
import { serviceLocator } from '../../../services';
import { Link as LinkIcon } from '@mui/icons-material';

import StatusCard from './StatusCard';
const qualityCheckService = serviceLocator.getQualityCheckService();

interface State {
    pageSpeedTestFails: any;
    brokenLinksFail: any;
}

const LighhouseIcon = (props: any) => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            {...props}
        >
            <path d="M22 1h-2v1h4v5l-2 2v13h2v2h-24v-2h2v-9h12v-4l-2-2v-5h4v-1h-2v-1h8v1zm-13 18h-3v4h3v-4zm5 0h-4v4h4v-4zm4 0h-3v4h3v-4zm-2-15h-2v2l1 1h1v-3zm3 0h-2v3h2v-3zm3 0h-2v3h1l1-1v-2z" />
        </svg>
    );
};

export class CardsDashboard extends React.Component<any, State> {

    constructor(props: any) {
        super(props);
        this.state = { pageSpeedTestFails: null, brokenLinksFail: null };
    }

    public async componentDidMount() {
        const failedWebsiteChecks = await qualityCheckService.listFailedWebsiteChecks();

        const pageSpeedTestFails = failedWebsiteChecks.filter(x => x.key.startsWith('PageSpeedTest'));
        const brokenLinksFail = failedWebsiteChecks.filter(x => x.key.startsWith('BrokenLinks'));

        this.setState({ pageSpeedTestFails, brokenLinksFail });
    }

    render() {
        const { pageSpeedTestFails, brokenLinksFail } = this.state;

        return (
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: 'repeat(2, minmax(0, 1fr))',
                    },
                    gap: 2.5,
                }}
            >
                <StatusCard
                    ok={brokenLinksFail == null ? null : brokenLinksFail.length === 0}
                    iconComponent={LinkIcon}
                    title="Broken links"
                    failCount={brokenLinksFail?.length}
                    description="Crawler reports for unreachable internal and outbound links."
                    eyebrow="Reachability"
                />
                <StatusCard
                    ok={pageSpeedTestFails == null ? null : pageSpeedTestFails.length === 0}
                    iconComponent={LighhouseIcon}
                    title="Page scores"
                    failCount={pageSpeedTestFails?.length}
                    description="Lighthouse scores across Accessibility, Best Practices, Performance, PWA, SEO."
                    eyebrow="Lighthouse"
                />
            </Box>
        );
    }
}
